import {createRootRoute, Outlet} from '@tanstack/react-router';
import {createPortal} from 'react-dom';
import {AppBootstrapComponent} from '../bootstrap/app.bootstrap.component';
import {AngularHost} from '../router/angular-host/angular-host';
import {useOutletSlot} from '../router/outlet/outlet-slot';
import {RenderNothing} from '../router/route-components';

function RootComponent() {
  const slot = useOutletSlot();
  return <>
    <AngularHost component={AppBootstrapComponent}/>
    {slot !== null && createPortal(<Outlet/>, slot)}
  </>;
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: RenderNothing,
});
